import React from "react"

export default function SectionLayout({ name, children, className }) {
  return (
    <section id={name} className={`px-3 py-16 lg:py-32 lg:px-6 ${className}`}>
      {children}
    </section>
  )
}
